import API_URL from "../apiConfig";
import { getCurrentSession } from "../services/auth";

export default async function apiFetch(path, options = {}) {
  const session = await getCurrentSession();

  // 🔍 DEBUG
  console.log("TOKEN:", session?.token);

  const res = await fetch(`${API_URL}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(session?.token
        ? { Authorization: `Bearer ${session.token}` }
        : {}),
      ...(options.headers || {}),
    },
    ...options,
    body:
      options.body && typeof options.body !== "string"
        ? JSON.stringify(options.body)
        : options.body,
  });

  if (!res.ok) {
    const text = await res.text();
    console.error("API ERROR:", text);
    throw new Error(text || "Error en la petición");
  }

  if (res.status === 204) return null;
  return res.json();
}
